import React from "react";
import "./css/Social.css"
export default function Social()
{
    return (
        <div className="social-container">
            <ul className="social-icons">
                <li><a href="https://www.linkedin.com/in/b-ranilbala/" target="_blank" rel="noopener noreferrer"><i className="fa fa-linkedin"></i></a></li>
                <li><a href="https://github.com/Ranilbala" target="_blank" rel="noopener noreferrer"><i className="fa fa-github"></i></a></li>
                <li><a href="https://leetcode.com/u/ranil_bala/" target="_blank" rel="noopener noreferrer"><i className="fa fa-code"></i></a></li>
                {/*<li><a href="https://twitter.com/ranil_bala" target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter"></i></a></li>*/}
                {/* <li><a href="https://www.facebook.com/ranil.bala/" target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook"></i></a></li> */}
                {/* <li><a href="https://www.instagram.com/ranilbala/" target="_blank" rel="noopener noreferrer"><i className="fa fa-instagram"></i></a></li> */}
            </ul>
        </div>
    )
}
